import { z } from 'zod'
import { Model } from '../../_kernel/architecture'
import { DateModel } from '../../_kernel/Date'

export const CancellationPolicyBasicValidation = z.object({
  fromDate: z.instanceof(DateModel, { message: '[CancellationPolicyBasic] fromDate is required' }),
})

export class CancellationPolicyBasic extends Model {
  static create({ fromDate }: z.infer<typeof CancellationPolicyBasicValidation>) {
    const validation = CancellationPolicyBasicValidation.safeParse({ fromDate })

    if (!validation.success) {
      throw new Error(validation.error.message)
    }

    return new CancellationPolicyBasic(validation.data.fromDate)
  }

  static fromJSON(json: ReturnType<CancellationPolicyBasic['toJSON']>) {
    return CancellationPolicyBasic.create({
      fromDate: DateModel.create({ value: json.fromDate }),
    })
  }

  constructor(private readonly _fromDate: DateModel) {
    super()
  }

  get fromDate() {
    return this._fromDate.value
  }

  toJSON() {
    return {
      fromDate: this._fromDate.value,
    }
  }

  getFromDateFormatted(locale: string) {
    return this._fromDate.getFormatted(locale)
  }
}
